import { render, staticRenderFns } from "./HonorariosExecucaoFiscalSefa.vue?vue&type=template&id=ded85c32&"
import script from "./HonorariosExecucaoFiscalSefa.vue?vue&type=script&lang=js&"
export * from "./HonorariosExecucaoFiscalSefa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports